import { PaintedScene } from '../PaintedScene';

export const FALLEN_LOG_PHASER_KEY = 'FallenLogScene' as const;
export const FALLEN_LOG_MANIFEST_KEY = 's-113-fallen-log' as const;

export class FallenLogScene extends PaintedScene {
  constructor() {
    super(FALLEN_LOG_PHASER_KEY, FALLEN_LOG_MANIFEST_KEY);
  }
}
